module.exports = __webpack_public_path__ + "static/media/residential.98e85673.jpeg";